var btnObtenir = document.querySelector("#btn-info a");
var btnObtenirEcole = document.querySelector(".btn-info-ecole a");
var btnObtenirSDG = document.querySelector(".btn-info-SDG a");
var btnObtenirCamps = document.querySelector(".btn-info-Camps a");
var btnObtenirAquatique = document.querySelector(".btn-info-Aquatique a");
var btnObtenirRepit = document.querySelector(".btn-info-Repit a");
var btnObtenirCA = document.querySelector(".btn-info-CA a");
var btnObtenirEtudiant = document.querySelector(".btn-info-Etudiant a");
var obtenirPortrait = document.querySelector(".btn-portrait-enfant a");
var formationVideo = document.querySelector(".formationVideo a");
var presentationEcole = document.querySelector(".presentationEcole a");
var btnInfolettre = document.querySelector(".btn-infolettre a");
var btnDemoMF = document.querySelector(".demo-MF a");
var btnDemoCPP = document.querySelector(".demo-CPP a");
// var btnRDV = document.querySelector(".btn-rdv a");
var procheAidants = document.querySelector(".procheAidants");
//btn soumission planitou
var btnSoumission = document.querySelectorAll(".btn-soumission a");
//btn soumission type de milieu
var btnSoumissionSDGS = document.querySelectorAll(".btn-soumissionSDGS a");
var btnSoumissionLOISIR = document.querySelectorAll(".btn-soumissionLOISIR a");
var btnSoumissionECOLE = document.querySelectorAll(".btn-soumissionECOLE a");

var overlay = document.getElementById("ac-wrapper");
var xClose = document.querySelector(".x-close");
var mainContent = document.getElementById("the-content");
var planitouModal = document.querySelector(".planitou-modal");
var planitouModalInner = document.querySelector(".planitou-modal-inner");
/** pop up obtenir trousse information */

if (overlay) {
    
    overlay.addEventListener('click', function(e) {
        e.stopPropagation();
        overlay.style.display="none";
        mainContent.className = mainContent.className.replace(new RegExp('modal-open'),"");
        planitouModalInner.innerHTML = "";
    });
   
    xClose.addEventListener('click', function(e) {
        e.stopPropagation();
        overlay.style.display="none";
        mainContent.className = mainContent.className.replace(new RegExp('modal-open'),"");
        planitouModalInner.innerHTML = "";
    });

    window.addEventListener('message', function (){
        var evntData = event.data;
        if (evntData && evntData.constructor == String) {
            var zf_ifrm_data = evntData.split("|");
            if ( zf_ifrm_data.length == 2 ) {
                var zf_perma = zf_ifrm_data[0];
                var zf_ifrm_ht_nw = ( parseInt(zf_ifrm_data[1], 10) + 15 ) + "px";
                var iframe = document.querySelector(".planitou-modal-inner iframe");
                if (!iframe){
                     iframe = document.querySelector(".planitou-div-inner iframe");
                }
                if ( (iframe.src).indexOf('formperma') > 0 && (iframe.src).indexOf(zf_perma) > 0 ) {
                    var prevIframeHeight = iframe.style.height;
                    if ( prevIframeHeight != zf_ifrm_ht_nw ) {
                        iframe.style.height = zf_ifrm_ht_nw;
                    }
                }
            }
        }
    }, false);
  
    /**pop up bientot disponible */

    if (procheAidants) {
        procheAidants.addEventListener('click',function(e){
            e.stopPropagation();
            document.getElementById('site-navigation').scrollIntoView({
                behavior: 'smooth' 
            });
            overlay.style.display = "block";
            mainContent.className = mainContent.className.replace(new RegExp('modal-open'),"") + " modal-open";
            planitouModalInner.innerHTML = "<div id='soon'>Bientôt disponible !<img class='popupimg' src='/wp-content/themes/planitou/assets/images/solution-proche-aidant.png' alt='proche-aidants'> <a href='https://planitou.ca/obtenir/'>Retour au choix de solution.</a></div>";
        });
    }

    if (btnObtenir) {
        btnObtenir.addEventListener('click',function(e){
            e.stopPropagation();
            overlay.style.display = "block";
            mainContent.className = mainContent.className.replace(new RegExp('modal-open'),"") + " modal-open";
        
            if (btnObtenir.id == "btn-info-42" ) {
                /**iframe cpe*/
                try{
                    var f = document.createElement("iframe");
                    f.src = 'https://forms.zohopublic.com/planitouca/form/SitewebTroussedinformationsServicesdegarde/formperma/UTayvYMmtnb9Lnqp8JGtUF9tF8Pm_7A7IBnO0uY13Os?zf_rszfm=1';
                    f.setAttribute('scrolling','no');
                    f.style.border="none";
                    f.style.height="calc(100% - 150px)";
                    f.style.width="100%";
                    f.style.transition="none";
                    var d = document.createElement("div");

                    d.setAttribute("id","zf_div_UTayvYMmtnb9Lnqp8JGtUF9tF8Pm_7A7IBnO0uY13Os");
                    d.appendChild(f);
                    planitouModalInner.innerHTML = "<h2>Obtenir la trousse d'information</h2>";
                    planitouModalInner.appendChild(d);
                
                }catch(e){}
    
            } else if (btnObtenir.id == "btn-info-46" ) {
                /**iframe SDG MF*/
                try{
                    var f = document.createElement("iframe");
                    f.src = 'https://forms.zohopublic.com/planitouca/form/TroussedinformationpourlesservicesdegardeMF/formperma/g9vxsGXOs9M6DAMnZ5aPxB-RnTcCNrrRgA4eCXLmPCg?zf_rszfm=1';
                    f.setAttribute('scrolling','no');
                    f.style.border="none";
                    f.style.height="calc(100% - 150px)";
                    f.style.width="100%";
                    f.style.transition="none";
                    var d = document.createElement("div");
        
                    d.setAttribute("id","zf_div_g9vxsGXOs9M6DAMnZ5aPxB-RnTcCNrrRgA4eCXLmPCg");
                    d.appendChild(f);
                    planitouModalInner.innerHTML = "<h2>Obtenir la trousse d'information</h2>";
                    planitouModalInner.appendChild(d);
                
                } catch(e){}
            }
        });
    }

    if (btnObtenirEcole) {
        btnObtenirEcole.addEventListener('click',function(e){
            e.stopPropagation();
            document.getElementById('site-navigation').scrollIntoView({
                behavior: 'smooth' 
            });
            overlay.style.display = "block";
            mainContent.className = mainContent.className.replace(new RegExp('modal-open'),"") + " modal-open";

            /**iframe Ecole*/
            try{
                var f = document.createElement("iframe");
                f.src = 'https://forms.zohopublic.com/planitouca/form/SitewebTroussedinformationscoles/formperma/eDiKiw9kn_TR3ZiW6nlk7gj0_T1-HAkB-N8bcv_EvPY?zf_rszfm=1';
                f.setAttribute('scrolling','no');
                f.style.border="none";
                f.style.height="calc(100% - 150px)";
                f.style.width="100%";
                f.style.transition="none";
                var d = document.createElement("div");
                d.setAttribute("id","zf_div_eDiKiw9kn_TR3ZiW6nlk7gj0_T1-HAkB-N8bcv_EvPY");
                d.appendChild(f);
                planitouModalInner.innerHTML = "<h2>Obtenir la trousse d'information</h2>";
                planitouModalInner.appendChild(d);
            
            }catch(e){}
        });
    }

    if (btnObtenirSDG) {

        btnObtenirSDG.addEventListener('click',function(e){
            e.stopPropagation();
            document.getElementById('site-navigation').scrollIntoView({
                behavior: 'smooth' 
            });
            overlay.style.display = "block";
            mainContent.className = mainContent.className.replace(new RegExp('modal-open'),"") + " modal-open";
        
            /**iframe SDG*/
            try{
                var f = document.createElement("iframe");
                f.src = 'https://forms.zohopublic.com/planitouca/form/TroussedinformationsServicesdegardeenmilieuscolair/formperma/DwQaaG1CT-JJ98nKsRBhwqyxj1CnSf1mZNqJT8j1fR8?zf_rszfm=1';
                f.setAttribute('scrolling','no');
                f.style.border="none";
                f.style.height="calc(100% - 150px)";
                f.style.width="100%";
                f.style.transition="none";
                var d = document.createElement("div");
                d.setAttribute("id","zf_div_mBXuX9rp3pJ_H6Vf8Vxd5igk8o39InEzmlFuYPwUSFI");
                d.appendChild(f);
                planitouModalInner.innerHTML = "<h2>Obtenir la trousse d'information</h2>";
                planitouModalInner.appendChild(d);
            
            }catch(e){}

        });
    }

    if (btnObtenirCamps) {

        btnObtenirCamps.addEventListener('click',function(e){
            e.stopPropagation();
            document.getElementById('site-navigation').scrollIntoView({
                behavior: 'smooth' 
            });
            overlay.style.display = "block";
            mainContent.className = mainContent.className.replace(new RegExp('modal-open'),"") + " modal-open";
        
            /**iframe SDG*/
            try{
                var f = document.createElement("iframe");
                f.src = 'https://forms.zohopublic.com/planitouca/form/SitewebTroussedinformationsCampsdejour/formperma/6ZeaYPKWvIjP-M-I7O9JFrxvdRrWbU_PTL7Ap7ABu8s?zf_rszfm=1';
                f.setAttribute('scrolling','no');
                f.style.border="none";
                f.style.height="calc(100% - 150px)";
                f.style.width="100%";
                f.style.transition="none";
                var d = document.createElement("div");
                d.setAttribute("id","zf_div_6ZeaYPKWvIjP-M-I7O9JFrxvdRrWbU_PTL7Ap7ABu8s");
                d.appendChild(f);
                planitouModalInner.innerHTML = "<h2>Obtenir la trousse d'information</h2>";
                planitouModalInner.appendChild(d);
            
            } catch(e){}
        });
    }

    if (btnObtenirAquatique) {

        btnObtenirAquatique.addEventListener('click',function(e){
            e.stopPropagation();

            document.getElementById('site-navigation').scrollIntoView({
                behavior: 'smooth' 
            });

            overlay.style.display = "block";
            mainContent.className = mainContent.className.replace(new RegExp('modal-open'),"") + " modal-open";
        
            /**iframe aquatique*/
            try{
                var f = document.createElement("iframe");
                f.src = 'https://forms.zohopublic.com/planitouca/form/Troussedinformationpourlescentresaquatiques/formperma/VhegL_Bl2EwXi0QjHl079GUO7Mi8eQA_4vOh90oWbSo?zf_rszfm=1';
                f.setAttribute('scrolling','no');
                f.style.border="none";
                f.style.height="calc(100% - 150px)";
                f.style.width="100%";
                f.style.transition="none";
                var d = document.createElement("div");
                d.setAttribute("id","zf_div_6ZeaYPKWvIjP-M-I7O9JFrxvdRrWbU_PTL7Ap7ABu8s");
                d.appendChild(f);
                planitouModalInner.innerHTML = "<h2>Obtenir la trousse d'information</h2>";
                planitouModalInner.appendChild(d);
            
            } catch(e){}
        });
    }

    if(btnObtenirRepit) {

        btnObtenirRepit.addEventListener('click',function(e){
            e.stopPropagation();
            document.getElementById('site-navigation').scrollIntoView({
                behavior: 'smooth' 
            });
            overlay.style.display = "block";
            mainContent.className = mainContent.className.replace(new RegExp('modal-open'),"") + " modal-open";
        
            /**iframe SDG*/
            try{
                var f = document.createElement("iframe");
                f.src = 'https://forms.zohopublic.com/planitouca/form/Troussedinformationpourrpitspersonnesbesoinspartic/formperma/5KbBazLIvtH5Bir7WElk0rh5lle0HLEGoRW06LcuCSk?zf_rszfm=1';
                f.setAttribute('scrolling','no');
                f.style.border="none";
                f.style.height="calc(100% - 150px)";
                f.style.width="100%";
                f.style.transition="none";
                var d = document.createElement("div");
                d.setAttribute("id","zf_div_5KbBazLIvtH5Bir7WElk0rh5lle0HLEGoRW06LcuCSk");
                d.appendChild(f);
                planitouModalInner.innerHTML = "<h2>Obtenir la trousse d'information</h2>";
                planitouModalInner.appendChild(d);
            
            }catch(e){}
        });
    }

    if (btnObtenirEtudiant) {

        btnObtenirEtudiant.addEventListener('click',function(e){
            e.stopPropagation();
            document.getElementById('site-navigation').scrollIntoView({
                behavior: 'smooth' 
            });
            overlay.style.display = "block";
            mainContent.className = mainContent.className.replace(new RegExp('modal-open'),"") + " modal-open";
            
            /**iframe SDG*/
            try{
                var f = document.createElement("iframe");
                f.src = 'https://forms.zohopublic.com/planitouca/form/Troussedinformationpourlesaccstudiantessansfrais/formperma/Mit46GeNGOc_YM04TmpSNFtv6NIQROmER8Es60I-Rdk?zf_rszfm=1';
                f.setAttribute('scrolling','no');
                f.style.border="none";
                f.style.height="calc(100% - 150px)";
                f.style.width="100%";
                f.style.transition="none";
                var d = document.createElement("div");
                d.setAttribute("id","zf_div_Mit46GeNGOc_YM04TmpSNFtv6NIQROmER8Es60I-Rdk");
                d.appendChild(f);
                planitouModalInner.innerHTML = "<h2>Obtenir la trousse d'information</h2>";
                planitouModalInner.appendChild(d);
            
            }catch(e){}
        });
    }


    if (obtenirPortrait){

        obtenirPortrait.addEventListener('click',function(e){
            e.stopPropagation();
            document.getElementById('site-navigation').scrollIntoView({
                behavior: 'smooth' 
            });
            overlay.style.display = "block";
            mainContent.className = mainContent.className.replace(new RegExp('modal-open'),"") + " modal-open";
        
            /**iframe SDG*/
            try{
                var f = document.createElement("iframe");
                f.src = 'https://forms.zohopublic.com/planitouca/form/SitewebPortraitdudveloppementtlchargSDG/formperma/x9cJBDUEkebi6wb96cWKhewfhQSbjZ4CPpv6r7Y-I3s?zf_rszfm=1';
                f.setAttribute('scrolling','no');
                f.style.border="none";
                f.style.height="calc(100% - 150px)";
                f.style.width="100%";
                f.style.transition="none";
                var d = document.createElement("div");
                d.setAttribute("id","zf_div_x9cJBDUEkebi6wb96cWKhewfhQSbjZ4CPpv6r7Y-I3s");
                d.appendChild(f);
                planitouModalInner.innerHTML = "<h2>Obtenir le modèle du portrait de l'enfant</h2>";
                planitouModalInner.appendChild(d);
            
            }catch(e){}
        });
    }
 

    if(btnSoumissionLOISIR){
        btnSoumissionLOISIR.forEach(function(btnSoumissionLOISIR, index){
            btnSoumissionLOISIR.addEventListener('click',function(e){
                e.stopPropagation();
                document.getElementById('site-navigation').scrollIntoView({
                    behavior: 'smooth' 
                });
                overlay.style.display = "block";
                mainContent.className = mainContent.className.replace(new RegExp('modal-open'),"") + " modal-open";
            
                /**iframe*/
                try{
                    var f = document.createElement("iframe");
                    f.src = 'https://forms.zohopublic.com/planitouca/form/DemandedesoumissionPlanitouLoisirs/formperma/z7tKDYBxCafNylVazYaFYMDL10SvenvSZ3aV7ZUxXj8?zf_rszfm=1';
                    f.setAttribute('scrolling','no');
                    f.style.border="none";
                    f.style.height="105vh";
                    f.style.width="100%";
                    f.style.transition="none";
                    var d = document.createElement("div");
                    d.setAttribute("id","zf_div_uT-gvaOVVahhN2a5kLte67gN2E_mrCoklLwhr5G174g");
                    d.appendChild(f);
                    planitouModalInner.innerHTML = "<h2>Obtenir une soumission</h2>";
                    planitouModalInner.appendChild(d);
                
                }catch(e){}
            });
        });
    }

    if(btnSoumission){
        btnSoumission.forEach(function(btnSoumission, index){
            btnSoumission.addEventListener('click',function(e){
                e.stopPropagation();
                document.getElementById('site-navigation').scrollIntoView({
                    behavior: 'smooth' 
                });
                overlay.style.display = "block";
                mainContent.className = mainContent.className.replace(new RegExp('modal-open'),"") + " modal-open";
            
                /**iframe*/
                try{
                    var f = document.createElement("iframe");
                    f.src = 'https://forms.zohopublic.com/planitouca/form/SitewebDemandedesoumissionPlanitou/formperma/uT-gvaOVVahhN2a5kLte67gN2E_mrCoklLwhr5G174g?zf_rszfm=1';
                    f.setAttribute('scrolling','no');
                    f.style.border="none";
                    f.style.height="105vh";
                    f.style.width="100%";
                    f.style.transition="none";
                    var d = document.createElement("div");
                    d.setAttribute("id","zf_div_uT-gvaOVVahhN2a5kLte67gN2E_mrCoklLwhr5G174g");
                    d.appendChild(f);
                    planitouModalInner.innerHTML = "<h2>Obtenir une soumission</h2>";
                    planitouModalInner.appendChild(d);
                
                }catch(e){}    
            });
        });
    }



    if(btnSoumissionECOLE){
        btnSoumissionECOLE.forEach(function(btnSoumissionECOLE, index){
            btnSoumissionECOLE.addEventListener('click',function(e){
                e.stopPropagation();
                document.getElementById('site-navigation').scrollIntoView({
                    behavior: 'smooth' 
                });
                overlay.style.display = "block";
                mainContent.className = mainContent.className.replace(new RegExp('modal-open'),"") + " modal-open";
            
                /**iframe*/
                try{
                    var f = document.createElement("iframe");
                    f.src = 'https://forms.zohopublic.com/planitouca/form/DemandedesoumissionServicesdegardeenmilieuscolaire/formperma/UKhp-2tUdqJhWn_peSV4F5HreYfWvH8-mBOBSlIoUZs?zf_rszfm=1';
                    f.setAttribute('scrolling','no');
                    f.style.border="none";
                    f.style.height="105vh";
                    f.style.width="100%";
                    f.style.transition="none";
                    var d = document.createElement("div");
                    d.setAttribute("id","zf_div_uT-gvaOVVahhN2a5kLte67gN2E_mrCoklLwhr5G174g");
                    d.appendChild(f);
                    planitouModalInner.innerHTML = "<h2>Obtenir une soumission</h2>";
                    planitouModalInner.appendChild(d);
                
                }catch(e){}    
            });
        });
    }


    if (btnSoumissionSDGS){
        btnSoumissionSDGS.forEach(function(btnSoumissionSDGS, index){
            btnSoumissionSDGS.addEventListener('click',function(e){
                e.stopPropagation();
                document.getElementById('site-navigation').scrollIntoView({
                    behavior: 'smooth' 
                });
                overlay.style.display = "block";
                mainContent.className = mainContent.className.replace(new RegExp('modal-open'),"") + " modal-open";
            
                /**iframe*/
                try{
                    var f = document.createElement("iframe");
                    f.src = 'https://forms.zohopublic.com/planitouca/form/DemandedesoumissionServicesdegardeenmilieuscolaire/formperma/UKhp-2tUdqJhWn_peSV4F5HreYfWvH8-mBOBSlIoUZs?zf_rszfm=1';
                    f.setAttribute('scrolling','no');
                    f.style.border="none";
                    f.style.height="105vh";
                    f.style.width="100%";
                    f.style.transition="none";
                    var d = document.createElement("div");
                    d.setAttribute("id","zf_div_uT-gvaOVVahhN2a5kLte67gN2E_mrCoklLwhr5G174g");
                    d.appendChild(f);
                    planitouModalInner.innerHTML = "<h2>Obtenir une soumission</h2>";
                    planitouModalInner.appendChild(d);
                
                }catch(e){}
            });
        });
    }

    if(formationVideo) {
        formationVideo.addEventListener('click',function(e){
            e.stopPropagation();
            document.getElementById('site-navigation').scrollIntoView({
                behavior: 'smooth' 
            });
            overlay.style.display = "block";
            mainContent.className = mainContent.className.replace(new RegExp('modal-open'),"") + " modal-open";
        
            /**iframe*/
            try{
                var f = document.createElement("iframe");
                f.src = 'https://forms.zohopublic.com/planitouca/form/Demandedeformationenvidoconfrence/formperma/ZhFqdz6R2wlQP4CqZuY-aZUJq0b06tcVLwzloWPUR9U?zf_rszfm=1';
                f.setAttribute('scrolling','no');
                f.style.border="none";
                f.style.height="105vh";
                f.style.width="100%";
                f.style.transition="none";
                var d = document.createElement("div");
                d.setAttribute("id","zf_div_ZhFqdz6R2wlQP4CqZuY-aZUJq0b06tcVLwzloWPUR9U");
                d.appendChild(f);
                planitouModalInner.innerHTML = "<h2>Obtenir une formation</h2>";
                planitouModalInner.appendChild(d);
                
            }catch(e){}
        });
    }

    if(presentationEcole){
        presentationEcole.addEventListener('click',function(e){
            e.stopPropagation();
            document.getElementById('site-navigation').scrollIntoView({
                behavior: 'smooth' 
            });
            overlay.style.display = "block";
            mainContent.className = mainContent.className.replace(new RegExp('modal-open'),"") + " modal-open";
        
            /**iframe*/
            try{
                var f = document.createElement("iframe");
                f.src = 'https://forms.zohopublic.com/planitouca/form/Demandedeprsentationpourlestudiantesetcolesdeforma/formperma/eXkujcK_SoNNyf65VrZrpMxhYemqxPCrd8OXPrkFJZ0?zf_rszfm=1';
                f.setAttribute('scrolling','no');
                f.style.border="none";
                f.style.height="105vh";
                f.style.width="100%";
                f.style.transition="none";
                var d = document.createElement("div");
                d.setAttribute("id","zf_div_eXkujcK_SoNNyf65VrZrpMxhYemqxPCrd8OXPrkFJZ0");
                d.appendChild(f);
                planitouModalInner.innerHTML = "<h2>Obtenir une présentation</h2>";
                planitouModalInner.appendChild(d);
            
            }catch(e){}
        });
    }

    if(btnDemoMF){
        btnDemoMF.addEventListener('click',function(e){
            e.stopPropagation();
            document.getElementById('site-navigation').scrollIntoView({
                behavior: 'smooth' 
            });
            overlay.style.display = "block";
            mainContent.className = mainContent.className.replace(new RegExp('modal-open'),"") + " modal-open";
        
            /**iframe*/
            try{
                var f = document.createElement("iframe");
                f.src = 'https://forms.zohopublic.com/planitouca/form/AccsdmoPlanitouPetiteenfance/formperma/Nrt3aJZBwj3JDxIUI4T49bUoU2lDfq0MnA2Hvla_zFo?zf_rszfm=1';
                f.setAttribute('scrolling','no');
                f.style.border="none";
                f.style.height="105vh";
                f.style.width="100%";
                f.style.transition="none";
                var d = document.createElement("div");
                d.setAttribute("id","zf_div_Nrt3aJZBwj3JDxIUI4T49bUoU2lDfq0MnA2Hvla_zFo");
                d.appendChild(f);
                planitouModalInner.innerHTML = "<h2>Obtenir une démonstration</h2>";
                planitouModalInner.appendChild(d);
            
            }catch(e){}
        });
    }


    if(btnDemoCPP){
        btnDemoCPP.addEventListener('click',function(e){
            e.stopPropagation();
            document.getElementById('site-navigation').scrollIntoView({
                behavior: 'smooth' 
            });
            overlay.style.display = "block";
            mainContent.className = mainContent.className.replace(new RegExp('modal-open'),"") + " modal-open";
        
            /**iframe*/
            try{
                var f = document.createElement("iframe");
                f.src = 'https://forms.zohopublic.com/planitouca/form/AccsdmoPlanitouClassesprscolairesetprimaires/formperma/16p7XDEG5oTmvI6c_vPuYLCMkJbIY-hkgIEqJuZcktE?zf_rszfm=1';
                f.setAttribute('scrolling','no');
                f.style.border="none";
                f.style.height="105vh";
                f.style.width="100%";
                f.style.transition="none";
                var d = document.createElement("div");
                d.setAttribute("id","zf_div_16p7XDEG5oTmvI6c_vPuYLCMkJbIY-hkgIEqJuZcktE");
                d.appendChild(f);
                planitouModalInner.innerHTML = "<h2>Obtenir une démonstration</h2>";
                planitouModalInner.appendChild(d);
            
            }catch(e){}
        });
    }

}


/**obtenir PLanitou */
var pageEtape = document.querySelector(".page-id-2065");
var planitouDivInner = document.querySelector(".planitou-div-inner");
//var planitouDivInnerImg = document.querySelector(".planitou-div-inner-img img");
var planitouDiv = document.querySelector(".obtenir-planitou-div");

if(pageEtape){

    window.addEventListener('message', function (){
        var evntData = event.data;
        if( evntData && evntData.constructor == String ){
            var zf_ifrm_data = evntData.split("|");
            if ( zf_ifrm_data.length == 2 ) {
                var zf_perma = zf_ifrm_data[0];
                var zf_ifrm_ht_nw = ( parseInt(zf_ifrm_data[1], 10) + 15 ) + "px";
                var iframe = document.querySelector(".planitou-div-inner iframe");
            
                if ( (iframe.src).indexOf('formperma') > 0 && (iframe.src).indexOf(zf_perma) > 0 ) {
                    var prevIframeHeight = iframe.style.height;
                    if ( prevIframeHeight != zf_ifrm_ht_nw ) {
                        iframe.style.height = zf_ifrm_ht_nw;
                    }
                }
            }
        }
    }, false);

    /**
     * cpe & prive
     */

    if(jQuery("body").hasClass("cpe-garderies")){
        /**iframe*/
        try{
            var f = document.createElement("iframe");
            f.src = 'https://forms.zohopublic.com/planitouca/form/ObtenirPlanitouCPEetGarderiesprives/formperma/agfuGzyAX9U2ES8Cnbr_5YXU41bYZ6za-q23jwNkrMQ?zf_rszfm=1';
            f.setAttribute('scrolling','no');
            f.style.border="none";
            f.style.width="100%";
            f.style.transition="none";
            var d = document.createElement("div");
            d.setAttribute("id","zf_div_JJiislozrbVcZMg5pH3371bWvJAJ_u9WMkje5ex5bY8");
            d.appendChild(f);
            var i = document.createElement("img");
            i.setAttribute('src','/wp-content/uploads/2023/04/cpe-form.png');
            planitouDivInner.appendChild(i);
            planitouDivInner.appendChild(d);
        }catch(e){}
    }
 
    /**
     * milieu familiale
     */
    if(jQuery("body").hasClass("mf")){

        /**iframe*/
        try{
            var f = document.createElement("iframe");
            f.src = 'https://forms.zohopublic.com/planitouca/form/ObtenirPlanitouServicesdegardeenmilieufamilial/formperma/U7h0YS1EtqZcZ9RAtCujgiHJNkprirVRF6QCG_nPbqE?zf_rszfm=1';
            f.setAttribute('scrolling','no');
            f.style.border="none";
            f.style.width="100%";
            f.style.transition="none";
            var d = document.createElement("div");
            d.setAttribute("id","zf_div_U7h0YS1EtqZcZ9RAtCujgiHJNkprirVRF6QCG_nPbqE");
            d.appendChild(f);
            var i = document.createElement("img");
            i.setAttribute('src','/wp-content/uploads/2023/01/sdg-form.png');
            planitouDivInner.appendChild(i);
            planitouDivInner.appendChild(d);

        }catch(e){}
    }

    /**
     * Classe prescolaire-primaire
     */
    if(jQuery("body").hasClass("classes-prescolaires-primaires")){

        /**iframe*/
        try{
            var f = document.createElement("iframe");
            f.src = 'https://forms.zohopublic.com/planitouca/form/ObtenirPlanitouClassesprscolairesetprimaires1/formperma/k5CA4pP26_3LYIAJafaBkFyH-b-rPMk7YDhwfelCVvA?zf_rszfm=1';
            f.setAttribute('scrolling','no');
            f.style.border="none";
            f.style.width="100%";
            f.style.transition="none";
            var d = document.createElement("div");
            d.setAttribute("id","zf_div_k5CA4pP26_3LYIAJafaBkFyH-b-rPMk7YDhwfelCVvA");
            d.appendChild(f);
            var i = document.createElement("img");
            i.setAttribute('src','/wp-content/uploads/2022/11/ecole-1.png');
            planitouDivInner.appendChild(i);
            planitouDivInner.appendChild(d);
        }catch(e){}
    }

    /**
     * SDG ecole
     */

    if(jQuery("body").hasClass("service-garde-scolaire")){

        /**iframe*/
        try{
            var f = document.createElement("iframe");
            f.src = 'https://forms.zohopublic.com/planitouca/form/ObtenirPlanitouServicedegardescolaire/formperma/CTygsW2DYAlrT7ucTe2A-C4xCekedrA4C6DtvMzCBLQ?zf_rszfm=1';
            f.setAttribute('scrolling','no');
            f.style.border="none";
            f.style.width="100%";
            f.style.transition="none";
            var d = document.createElement("div");
            d.setAttribute("id","zf_div_CTygsW2DYAlrT7ucTe2A-C4xCekedrA4C6DtvMzCBLQ");
            d.appendChild(f);
            var i = document.createElement("img");
            i.setAttribute('src','/wp-content/uploads/2022/11/ecole-sdg.png');
            planitouDivInner.appendChild(i);
            planitouDivInner.appendChild(d);
        }catch(e){}
    }

    /**
     * Camps de jour
     */
    if(jQuery("body").hasClass("camps")){

        /**iframe*/
        try{
            var f = document.createElement("iframe");
            f.src = 'https://forms.zohopublic.com/planitouca/form/ObtenirPlanitouCampsdejouretdevacances/formperma/9JF7IGqVvGFSjMS14JnTjA4h6tyiLjIzhHTjhIvEXlk?zf_rszfm=1';
            f.setAttribute('scrolling','no');
            f.style.border="none";
            f.style.width="100%";
            f.style.transition="none";
            var d = document.createElement("div");
            d.setAttribute("id","zf_div_9JF7IGqVvGFSjMS14JnTjA4h6tyiLjIzhHTjhIvEXlk");
            d.appendChild(f);
            var i = document.createElement("img");
            i.setAttribute('src','/wp-content/uploads/2022/11/camps-de-jour.png');
            planitouDivInner.appendChild(i);
            planitouDivInner.appendChild(d);

        }catch(e){}
    }

    /**
     * Camps de jour repits personne \ besoin particulier
     */
    if(jQuery("body").hasClass("repits")){

        /**iframe*/
        try{
            var f = document.createElement("iframe");
            f.src = 'https://forms.zohopublic.com/planitouca/form/ObtenirPlanitouRpitspourpersonnesbesoinsparticulie/formperma/SOBUszbMU6BWHLS8s24vnsHh7SRk1lla1-kXt2lb5W4?zf_rszfm=1';
            f.setAttribute('scrolling','no');
            f.style.border="none";
            f.style.width="100%";
            f.style.transition="none";
            var d = document.createElement("div");
            d.setAttribute("id","zf_div_SOBUszbMU6BWHLS8s24vnsHh7SRk1lla1-kXt2lb5W4");
            d.appendChild(f);
            var i = document.createElement("img");
            i.setAttribute('src','/wp-content/uploads/2022/11/camps-de-jour-special-1.png');
            planitouDivInner.appendChild(i);
            planitouDivInner.appendChild(d);
        }catch(e){}
    }

    /**
     * Centre aquatique
     */
    if(jQuery("body").hasClass("centres-aquatiques")){

        /**iframe*/
        try{
            var f = document.createElement("iframe");
            f.src = 'https://forms.zohopublic.com/planitouca/form/ObtenirPlanitouCentresaquatiques/formperma/4_jXW4W_K6wIuLWxQShZAQ9bSpl5RJ-_fky-B3ZGcgM?zf_rszfm=1';
            f.setAttribute('scrolling','no');
            f.style.border="none";
            f.style.width="100%";
            f.style.transition="none";
            var d = document.createElement("div");
            d.setAttribute("id","zf_div_4_jXW4W_K6wIuLWxQShZAQ9bSpl5RJ-_fky-B3ZGcgM");
            d.appendChild(f);
            var i = document.createElement("img");
            i.setAttribute('src','/wp-content/uploads/2023/01/centres-aquatiques-form.png');
            planitouDivInner.appendChild(i);
            planitouDivInner.appendChild(d);

        }catch(e){}
    }

    /**
     * autre loisir
     */
    if(jQuery("body").hasClass("autres-loisirs")){

        /**iframe*/
        try{
            var f = document.createElement("iframe");
            f.src = 'https://forms.zohopublic.com/planitouca/form/ObtenirPlanitouCampsdejouretdevacances1/formperma/JJiislozrbVcZMg5pH3371bWvJAJ_u9WMkje5ex5bY8?zf_rszfm=1';
            f.setAttribute('scrolling','no');
            f.style.border="none";
            f.style.width="100%";
            f.style.transition="none";
            var d = document.createElement("div");
            d.setAttribute("id","zf_div_JJiislozrbVcZMg5pH3371bWvJAJ_u9WMkje5ex5bY8");
            d.appendChild(f);
            var i = document.createElement("img");
            i.setAttribute('src','/wp-content/uploads/2022/11/loisir.png');
            planitouDivInner.appendChild(i);
            planitouDivInner.appendChild(d);
        }catch(e){}
    }
}

/**pop up infolettre */
if(btnInfolettre){
        btnInfolettre.addEventListener('click',function(e){
            e.stopPropagation();
            loadZCPopup('3za4278926df81047cb9bbeded473b1265f7115306aef980602d3b1ea25da348e8','ZCFORMVIEW','3z3106d9066c980a67746941ea84ccc44e')
        });
}

